/* eslint-disable import/no-anonymous-default-export */
export default {
  ATIVO: 1,
  INATIVO: 2,
  CANCELADO: 3,
};
